import { Flex, theme } from '@betterment/style-closet-react';
import ContentLoader from 'react-content-loader';

import { IMAGE_LOADER_SECONDARY_COLOR } from './constants';

const GoalImageLoader: React.FC<React.PropsWithChildren<{ size: string; rounded: boolean }>> = ({ size, rounded }) => {
  return (
    <Flex display="block" flexBasis={size}>
      <ContentLoader
        style={{ display: 'block', width: size, height: size, borderRadius: rounded ? '10px' : undefined }}
        ariaLabel="Loading goal image"
        gradientRatio={2}
        speed={0.99}
        interval={0.2}
        primaryColor={theme.colors.bmtGrey10}
        secondaryColor={IMAGE_LOADER_SECONDARY_COLOR}
      />
    </Flex>
  );
};

export default GoalImageLoader;
